export default {
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    articles: 'Articles',
    spreadsheet: 'Tableur',
    shoppingGuide: 'Guide d\'achat',
    review: 'Avis',
    shipping: 'Livraison',
    coupon: 'Coupon',
    language: 'Langue',
  },
  footer: {
    about: 'À propos d\'AllChinaBuy Spreadsheet',
    links: 'Liens rapides',
    legal: 'Mentions légales',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d\'utilisation',
    disclaimer: 'Avertissement',
    copyright: 'AllChinaBuy Spreadsheet. Tous droits réservés.',
    description: 'Une ressource d\'information indépendante pour aider les acheteurs à rechercher des produits, vendeurs, livraison et contrôle qualité avant de commander.',
  },
  common: {
    readMore: 'Lire la suite',
    explore: 'Explorer',
    buyNow: 'Acheter maintenant',
    continueToMain: 'Continuer vers le site principal',
    search: 'Rechercher',
    breadcrumbHome: 'Accueil',
    close: 'Fermer',
    open: 'Ouvrir',
  },
};